import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://kjeylzvmaolngufvadpy.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtqZXlsenZtYW9sbmd1ZnZhZHB5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njc0NjMzMDIsImV4cCI6MjA4MzAzOTMwMn0.yUQNX2YDuuUN8dslePDj_hUafUyU--EgKOTI_O8ClHI';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Admin email list - users with these emails get admin access
export const ADMIN_EMAILS = [
  'cindy@pacin.ca',
  'alfredchau0@gmail.com'
];

export function isAdminEmail(email: string | undefined): boolean {
  if (!email) return false;
  return ADMIN_EMAILS.includes(email.toLowerCase());
}
